import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from './ui/dialog.jsx';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';
import { Card, CardContent } from './ui/card';
import { CheckCircle } from 'lucide-react';

const TemplateModal = ({
  open,
  onOpenChange,
  editingTemplate,
  novoTemplate,
  setNovoTemplate,
  competenciasDisponiveis,
  loading,
  onSave,
  onCancel
}) => {
  
  const toggleCompetencia = (competenciaId) => {
    setNovoTemplate(prev => ({
      ...prev,
      competencias: prev.competencias.includes(competenciaId)
        ? prev.competencias.filter(id => id !== competenciaId)
        : [...prev.competencias, competenciaId]
    }));
  };
  
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            {editingTemplate ? 'Editar Template' : 'Criar Novo Template'}
          </DialogTitle>
          <DialogDescription>
            {editingTemplate 
              ? 'Atualize as informações do template personalizado'
              : 'Crie um template personalizado selecionando competências existentes'}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-6 py-4">
          <div className="grid grid-cols-1 gap-4">
            <div>
              <Label htmlFor="nome">Nome do Template *</Label>
              <Input
                id="nome"
                value={novoTemplate.nome}
                onChange={(e) => setNovoTemplate(prev => ({ ...prev, nome: e.target.value }))}
                placeholder="Ex: Avaliação de Liderança"
              />
            </div>
            <div>
              <Label htmlFor="descricao">Descrição *</Label>
              <Textarea
                id="descricao"
                value={novoTemplate.descricao}
                onChange={(e) => setNovoTemplate(prev => ({ ...prev, descricao: e.target.value }))}
                placeholder="Descreva o propósito deste template"
                rows={3}
              />
            </div>
          </div>

          <div className="space-y-3">
            <Label className="text-base font-semibold">Distribuição de Pesos (%)</Label>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label htmlFor="peso_metas" className="text-sm">Peso Metas</Label>
                <Input
                  id="peso_metas"
                  type="number"
                  min="0"
                  max="100"
                  value={novoTemplate.peso_metas}
                  onChange={(e) => setNovoTemplate(prev => ({ ...prev, peso_metas: parseInt(e.target.value) || 0 }))}
                />
              </div>
              <div>
                <Label htmlFor="peso_competencias" className="text-sm">Peso Competências</Label>
                <Input
                  id="peso_competencias"
                  type="number"
                  min="0"
                  max="100"
                  value={novoTemplate.peso_competencias}
                  onChange={(e) => setNovoTemplate(prev => ({ ...prev, peso_competencias: parseInt(e.target.value) || 0 }))}
                />
              </div>
            </div>
          </div>

          <div className="space-y-3">
            <Label className="text-base font-semibold">
              Selecione as Competências ({novoTemplate.competencias.length} selecionadas)
            </Label>
            
            <div className="border rounded-lg p-3 space-y-2 max-h-64 overflow-y-auto bg-gray-50">
              {competenciasDisponiveis && competenciasDisponiveis.length > 0 ? (
                competenciasDisponiveis.map(comp => (
                  <Card 
                    key={comp.id}
                    className={`cursor-pointer border-2 transition-all ${
                      novoTemplate.competencias.includes(comp.id)
                        ? 'border-purple-600 bg-purple-50'
                        : 'border-gray-200 hover:border-purple-300'
                    }`}
                    onClick={() => toggleCompetencia(comp.id)}
                  >
                    <CardContent className="pt-3 pb-3">
                      <div className="flex items-center justify-between">
                        <div className="flex-1">
                          <p className="font-medium text-sm">{comp.name}</p>
                          {comp.description && (
                            <p className="text-xs text-gray-600">{comp.description}</p>
                          )}
                        </div>
                        {novoTemplate.competencias.includes(comp.id) && (
                          <CheckCircle className="w-5 h-5 text-purple-600 flex-shrink-0 ml-2" />
                        )}
                      </div>
                    </CardContent>
                  </Card>
                ))
              ) : (
                <div className="text-center py-8 text-gray-500">
                  <p>Nenhuma competência disponível. Cadastre competências primeiro.</p>
                </div>
              )}
            </div>
          </div>
        </div>

        <DialogFooter>
          <Button
            variant="outline"
            onClick={onCancel}
          >
            Cancelar
          </Button>
          <Button
            onClick={onSave}
            disabled={loading || !novoTemplate.nome || novoTemplate.competencias.length === 0}
          >
            {loading ? 'Salvando...' : editingTemplate ? 'Atualizar' : 'Criar Template'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default TemplateModal;
